import { useQuery } from '@hooks/reactQuery';

import { getRUStatusDashboardAdministrativeState } from '@api/ruStatusDashboard';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { RU_DASHBOARD_ADMINISTRATIVE_STATE } from '@constants/queryKeys';

interface IUseQueryRUDashboardStatusAdministrativeState {
	ruDashboardStatusAdministrativeState: TSelectOption<string>[];
	isLoadingRUDashboardStatusAdministrative: boolean;
}

export const useQueryRUDashboardStatusAdministrativeState = (): IUseQueryRUDashboardStatusAdministrativeState => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [RU_DASHBOARD_ADMINISTRATIVE_STATE],
		queryFn: getRUStatusDashboardAdministrativeState,
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'name',
			labelKey: 'title',
		}),
		allowedRoles: [
			EUserRoles.smoLightUpdater,
			EUserRoles.smoLightViewer,
		],
		...refetchOptions,
	});

	return {
		ruDashboardStatusAdministrativeState: data || [],
		isLoadingRUDashboardStatusAdministrative: isInitialLoading,
	};
};
